export default "__VITE_ASSET__Ba5FI56___"